import type {StepTypeRect} from '@blesk-frontend/api';

export function getBoundingRect(rects: StepTypeRect[]): {
  x: number;
  y: number;
  width: number;
  height: number;
} | null {
  const initialRect = rects.at(0);
  if (!initialRect) return null;

  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  for (const {x, y, width, height} of rects) {
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x + width);
    maxY = Math.max(maxY, y + height);
  }

  return {x: minX, y: minY, width: maxX - minX, height: maxY - minY};
}
